import React, { useState, useEffect, useRef } from 'react';
import './css/MemberProfile.module.css';
import Violations from './ViolationsbyMember';
import axios from 'axios';
import api, { API_BASE_URL } from "../../src/utils/api";

const MemberProfile = ({ member }) => {
  const [location, setLocation] = useState('');
  const mapRef = useRef(null); // Reference for the map container

  useEffect(() => {
    if (member && window.google) {
      const fetchLocation = async () => {
        try {
          const response = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
            params: {
              address: member.FullAddress,
              key: 'AIzaSyBWcsaXq1Nuot6pj35zUfEqkHtCf7o6t8Y'
            }
          });
          const loc = response.data.results[0].geometry.location;
          setLocation(response.data.results[0].formatted_address);
          initMap(loc.lat, loc.lng);
        } catch (error) {
          console.error('Failed to fetch location:', error);
          setLocation('Location not found');
        }
      };

      fetchLocation();
    }
  }, [member]);

  // Initialize and display the map
  const initMap = (lat, lng) => {
    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat, lng },
      zoom: 19, // Set your desired zoom level, e.g., 12
      mapTypeId: window.google.maps.MapTypeId.SATELLITE // Set map type to satellite
    });
  
    new window.google.maps.Marker({
      position: { lat, lng },
      map,
      title: member ? `${member.FirstName} ${member.LastName}` : 'Location'
    });
  };

  if (!member) {
    return <div className="profile-container">Member not found</div>;
  }

  return (
    <div className="member-detail-container">
  <div className="profile-container">
    <img
      src={`${API_BASE_URL}/images/${encodeURIComponent(member.PhotoGraphicFileName?.trim() || '')}`}
      alt={`${member.FirstName} ${member.LastName}`}
      className="profile-image"
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = '/img/100x100.png';
      }}
    />
    <div className="profile-info">
      <h1>{`${member.FirstName} ${member.LastName}`}</h1>
            <h2>{member.ClubMemberCode}</h2>
      <p><i className="fas fa-map-marker-alt"></i> {location}</p>
      <div className="profile-details">
        <p><strong>Gender:</strong> {member.Gender}</p>
        
        <p><strong>Birth Date:</strong> {new Date(member.BirthDate).toLocaleDateString()}</p>
        <p><strong>Join Date:</strong> {new Date(member.JoinDate).toLocaleDateString()}</p>
        <p><strong>Status:</strong> {member.ClubStatusRuleCode}</p>
      </div>
    </div>
  </div>
  <div className='map-container'>
  <div ref={mapRef} className="map-container"></div>
  </div>
</div>


  );
};

export default MemberProfile;
